import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar
} from 'reactstrap';  
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { findCidadeByEstado } from "../../Services/CidadeService";
import { addOrgao, updateOrgao } from "../../Services/OrgaoService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { environment } from '../../environment';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      checkAll: false,

      user: {},
      users: [],
      checkboxUser: [],
      checkboxUserSelected: [],

      estados: [],
      statesList: [],
      selectedStates: [{value:0, label: this.props.t('forms.loading')+"..."}],

      cidades: [],
      citiesList: [],
      selectedCities: [],

      orgaos: [],
      selectedOrgao: '',
      selectOptionsO: [],

      data: {
        id: '',
				name: '',
        cidade: {},
        estado: {},
        userCreate: {},
        userUpdate: {},
        orgao: null,
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }
      
      data['userUpdate'] = this.state.user;

      let request = {
        orgao: data,
        orgaoUserList: this.getGroupUser()
      };


      if(data.id === undefined || data.id === null || data.id === ''){

        data['userCreate'] = data.userUpdate;

        addOrgao(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear({});              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateOrgao(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    if(data.estado === undefined || data.estado === null || 
      data.estado.id === undefined || data.estado.id === null || data.estado.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldState'));
      validated = false;
    }

    if(data.cidade === undefined || data.cidade === null || 
      data.cidade.id === undefined || data.cidade.id === null || data.cidade.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldCity'));
      validated = false;
    }

    return validated;
  }

  getGroupUser() {
    let orgaoUser = [];
    if(this.state.checkboxUserSelected.length > 0){
      for(let j = 0; j < this.state.checkboxUserSelected.length; j++){
        for(let i = 0; i < this.state.users.length; i++){
          if(this.state.checkboxUserSelected[j].value === this.state.users[i].id){
            orgaoUser.push( {applicationUser: this.state.users[i]} );
            break;
          }
        }
      }
    }
    return orgaoUser;
  }

  loadCidades(estado, cidade){
    findCidadeByEstado(estado.id)
    .then(response => {
      if(response === undefined){
        response = [];
      }
      let options = [];
      let cidades = [];
      let selectedCities = [];
      if(response !== undefined && response.error === undefined){
        cidades = response;
        if(cidades !== undefined && cidades !== null && cidades.length > 0){
          for(let i = 0; i < cidades.length; i++){
            options.push({value:cidades[i].id, label: cidades[i].name});
          }
          this.setState({ 
            cidades,
            citiesList: options,
            selectedCities
          }, () => {
            if(cidade !== null){
              this.setCidade(cidade);
            }
          });
        }
      } else {
        if(response.errors === undefined){
          response = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          response = [];
          this.show('danger', response.errors[0].defaultMessage);
        }
      }
    });
  }

  setCidade(cidade){
    const data = { ...this.state.data }

    data["cidade"] = '';
    let selectedCities = [];
    if(cidade !== null){
      for(let i = 0; i < this.state.cidades.length; i++){
        if(this.state.cidades[i].id === cidade.id){
          selectedCities.push({value: this.state.cidades[i].id, label: this.state.cidades[i].name});
          data["cidade"] = this.state.cidades[i];
          break;
        }
      }
    }
    this.setState({ data, selectedCities }, () => {});
  }

  setEstado(estado, cidade){
    const data = { ...this.state.data }

    data["estado"] = '';
    data["cidade"] = '';
    let selectedStates = [];
    let citiesList = [];
    let selectedCities = [];
    if(estado !== null){
      for(let e = 0; e < this.state.estados.length; e++){
        if(this.state.estados[e].id === estado.id){
          selectedStates.push({value: this.state.estados[e].id, label: this.state.estados[e].name});
          data["estado"] = this.state.estados[e];
          selectedCities.push({value:0, label: this.props.t('forms.loading')+"..."});
          break;
        }
      }
    }
    this.setState({ data, selectedStates, citiesList, selectedCities }, () => {
      if(selectedStates.length > 0){
        this.loadCidades(estado, cidade);
      }
    });
  }

  loadData(selected, users, user, estados, orgaos, orgaoUsers) {
    let options = [];
    let optionsSelected = [];
    let obj = {};

    if(users !== undefined && users !== null && users.length > 0 && this.state.users.length === 0){
      options = [];
      optionsSelected = [];
      if(orgaoUsers !== undefined && orgaoUsers !== null && orgaoUsers.length > 0){
        for(let i = 0; i < users.length; i++){
          obj = {value:users[i].id, label: users[i].firstName + ' ' + users[i].lastName, checked: false};
          for(let j = 0; j < orgaoUsers.length; j++){
            if(users[i].id === orgaoUsers[j].applicationUser.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < users.length; i++){
          options.push({value:users[i].id, label: users[i].firstName + ' ' + users[i].lastName, checked: false});
        }
      }

      this.setState({ 
        checkboxUser: options,
        checkboxUserSelected: optionsSelected,
        users: users 
      });
    }

    if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
      options = [];
      for(let i = 0; i < estados.length; i++){
        options.push({value:estados[i].id, label: estados[i].name});
      }
      this.setState({ 
        statesList: options, 
        estados: estados 
      });
    }

    if(orgaos !== undefined && orgaos !== null && orgaos.length > 0 && this.state.orgaos.length === 0){
      options = [];
      for(let i = 0; i < orgaos.length; i++){
        options.push({value:orgaos[i].id, label: orgaos[i].name});
      }
      this.setState({ 
        selectOptionsO: options, 
        orgaos: orgaos 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear(user);
      }else {

        let selectedOrgao = '';
        if(selected.orgao !== undefined && selected.orgao !== null && selected.orgao.id !== null){
          selectedOrgao = {value:selected.orgao.id, label: selected.orgao.name};
        }

        this.setState({ 
          data: selected, user, selectedOrgao
        }, () => {
          if(selected.estado !== undefined && selected.estado !== null && selected.estado.id !== null){
            this.setEstado(selected.estado, selected.cidade);
          }
        });
      }
    }
  }

  componentDidMount() {
    const { selected, users, user, estados, orgaos, orgaoUsers } = this.props;
    this.loadData(selected, users, user, estados, orgaos, orgaoUsers);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.estados !== this.props.estados || 
        props.users !== this.props.users || props.orgaos !== this.props.orgaos || 
        props.orgaoUsers !== this.props.orgaoUsers){
      this.loadData(this.props.selected, this.props.users, this.props.user, this.props.estados, this.props.orgaos, this.props.orgaoUsers);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxOrgaoUserAll(){
    let selecteds = [];

    if(this.state.checkboxUser.length > 0){
      for(let i = 0; i < this.state.checkboxUser.length; i++){
        this.state.checkboxUser[i].checked = !this.state.checkAll;
        if(!this.state.checkAll){
          selecteds.push(this.state.checkboxUser[i]);
        }
      }
    }
    this.setState({ checkboxUserSelected: selecteds, checkAll: !this.state.checkAll });
  }

  updateCheckboxOrgaoUser(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxUserSelected.length > 0){
      for(let i = 0; i < this.state.checkboxUserSelected.length; i++){
        if(this.state.checkboxUserSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxUserSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxUserSelected: selecteds });
  }

  updateEstadoSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setEstado({id: event[j].value}, null);
      }
    }else{
      this.setEstado(null, null);
    }
  }

  updateCidadeSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setCidade({id: event[j].value});
      }
    }else{
      this.setCidade(null);
    }
  }

  updateOrgaoSelect(event) {
    const data = { ...this.state.data }

    let selectedOrgao = '';

    data["orgao"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsO.length; i++){
          if(this.state.selectOptionsO[i].value === event[j].value){
            selectedOrgao = event[j];
            
            for(let e = 0; e < this.state.orgaos.length; e++){
              if(this.state.orgaos[e].id === selectedOrgao.value){
                data["orgao"] = this.state.orgaos[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedOrgao });
  }


  clear(user){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['status'] = '';
    data['cidade'] = {};
    data['estado'] = {};
    data['userCreate'] = {};
    data['userUpdate'] = {};
    data['orgao'] = null;
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data,
      checkboxUserSelected: [],
      user,
      selectedCities: [],
      selectedStates: [],
    }, () => {});
  }

  cancel(event) {
    this.clear({});
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_ORGAO_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesUser = [];

    let total = this.state.checkboxUser.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesUser.push(
          <div key={"divsecurityUser_"+this.state.checkboxUser[i].value} className='form__form-inline' style={{width: '270px'}}>
            <input type="checkbox" 
              id={"checkboxsecurityUser_"+this.state.checkboxUser[i].value} 
              name={"checkboxsecurityUser_"+this.state.checkboxUser[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxOrgaoUser(this.state.checkboxUser[i])}
              checked={this.state.checkboxUserSelected.includes(this.state.checkboxUser[i])} 
            />
              <label 
                key={"labelsecurityUser_"+this.state.checkboxUser[i].value}
                htmlFor={"checkboxsecurityUser_"+this.state.checkboxUser[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxUser[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.estado')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "false"
                      maxMenuHeight="200px"
                      name="estado"
                      value={this.state.selectedStates}
                      onChange={e => this.updateEstadoSelect(e)}
                      options={this.state.statesList}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.cidade')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "false"
                      maxMenuHeight="200px"
                      name="cidade"
                      value={this.state.selectedCities}
                      onChange={e => this.updateCidadeSelect(e)}
                      options={this.state.citiesList}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form__half">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.orgaoResp')} 
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "true"
                      maxMenuHeight="150px"
                      name="orgao"
                      value={this.state.selectedOrgao}
                      onChange={e => this.updateOrgaoSelect(e)}
                      options={this.state.selectOptionsO}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
              </div>
              
              <div className="form__half"></div>

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <input type="hidden" 
                    name="id"
                    value={this.state.data.id} />
                  <input type="text" 
                    name="name"
                    value={this.state.data.name}
                    onChange={e => this.updateField(e)}
                    required
                  />
                </div>
              </div>



              <div className="form__form-group">
                <div style={{float: 'left', marginRight: '5px'}}>
                  <span className="form__form-group-label">
                    {t('forms.users_form.title')}
                  </span>
                </div>
                <div style={{float: 'left'}}>
                  <input type="checkbox" 
                    id={"checkboxsecurityProfilesALL"} 
                    name={"checkboxsecurityProfilesAll"} 
                    style={{float: 'left', width: '30px', height: '18px'}}
                    onChange={e => this.updateCheckboxOrgaoUserAll()}
                  /> 
                  <label 
                    key={"labelsecurityProfilesAll"}
                    htmlFor={"checkboxsecurityProfilesAll"}
                    style={{margin: 0, height: '25px'}}>
                    {t('forms.checkAll')} 
                  </label>
                </div>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', fontSize: '12px'}}>
                  
                  {checkboxesUser}

                </div>
              </div>


              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'securityProfileEdit', 
})(withTranslation('common')(CrudEdit));
